module.exports = __webpack_public_path__ + "img/Narabi_EU_Map_960x480.e6179088.png";